<template>
    <footer class="foot">
      <div class="w1124">
        <div class="logo flexDiv">
          <span><img src="../assets/img/b-logo.png" alt="logo"></span>
          <span><em>商学院</em><i>招生代码：5706</i></span>
        </div>
        <div class="address">
            <p>学院地址：四川省成都市金堂县大学城   |   邮编：610400   |   联系电话：028-6793-5809   </p>
            <p class="beian">版权所有 西南交通大学希望学院  备案号：<a href="https://beian.miit.gov.cn/" target="_blank" style="color: white; display: inline-block;">蜀ICP备10006587号-1</a></p>
        </div>
      </div>
    </footer>
</template>
<script>
export default{
    name:'foot',
    data(){
        return{
            codeData:[]
        }
    },
    created(){
        this.codeData = this.Base.GetNewsInfoByCid(5516,true,1,'',3);
        // console.log(this.codeData,'codeData')
    }
}
</script>
<style lang="less" scoped>
.foot{
  padding-top: 34px;
  height: 196px;
  text-align: center;
  background: #0376be;
  .logo{
    margin: 0px auto;
    justify-content: center;
    span{
      display: block;
      margin: 0 18px;
      &:first-child{
        width: 435px;
        height: 67px;
        position: relative;
        &::after{
          content: '';
          width: 1px;
          height: 64px;
          background-color: #ffffff;
          position: absolute;
          right: -18px;
          bottom: 0;
        }
      }
      &:last-child{
        text-align: left;
        margin-top: 16px;
        em{
          display: block;
          font-size: 24px;
          font-weight: bold;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: 5px;
          color: #ffffff;
        }
        i{
          display: block;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 30px;
          letter-spacing: 1px;
          color: #ffffff;
        }
      }
    }
  }
  .address{
    margin-top: 28px;
    p{
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 36px;
      letter-spacing: 2px;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue